<template>
    <div class="public_container mobile_clockIn_record_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
            <div class="mobile_head_operate">
                <span @click="handleClickShowTypeChange"
                    ><i class="iconfont icon-qiehuan"></i>切换至{{ currentType == "mine" ? "团队" : "我的" }}</span
                >
            </div>
        </div>
        <div class="top_wrap" v-if="currentType == 'team'">
            <div class="top_static_wrap">
                <van-dropdown-menu>
                    <van-dropdown-item
                        v-model="group_calc_type"
                        :options="staticTypeOption"
                        @change="groupCalcTypeChange"
                    />
                </van-dropdown-menu>
                <span class="link-label" @click="handleClickSelectUserDepartment">选择部门/人员</span>
            </div>
            <div class="top_static_time">
                <template v-if="group_calc_type == 'DAILY'">
                    <Calendar
                        ref="calendar"
                        @month-change="updateMonth"
                        @day-change="updateDay"
                        :monthStatus="monthCheckDateList"
                    />
                </template>
                <template v-else-if="group_calc_type == 'WEEKLY'">
                    <WeekCalendar ref="weekCalendar" @week-change="updateWeek" />
                </template>
                <template v-else>
                    <MonthCalendar @groun-month-change="updateGroupMonth" />
                </template>
            </div>
            <div class="top_static_count">
                <div>
                    <p>打卡人数</p>
                    <p>{{ census.punch_user_num }}</p>
                </div>
                <div>
                    <p>打卡次数</p>
                    <p>{{ census.punch_times }}</p>
                </div>
            </div>
        </div>
        <div class="top_wrap top_wrap_padding" v-else>
            <Calendar
                ref="calendar"
                @month-change="updateMonth"
                @day-change="updateDay"
                :monthStatus="monthCheckDateList"
            />
        </div>
        <div class="mobile_container">
            <ul class="list_content" v-if="currentType == 'team'">
                <li class="list_item_team" v-for="item in clockInRecordList" :key="item.id">
                    <div class="list_item_team_top">
                        <div class="list_item_team_img">
                            <img :src="item.avatar ? item.avatar : defaultImg" alt="" />
                        </div>
                        <div class="list_item_team_user">
                            <p>
                                <span class="name">{{ item.name }}</span
                                ><span>{{ item.department_name }}</span>
                            </p>
                            <p>打卡次数：{{ item.punch_times }}</p>
                        </div>
                        <div class="list_item_team_icon" @click="handleClickExpendChange(item)">
                            <van-icon name="arrow-up" v-if="item.isExtend" />
                            <van-icon name="arrow-down" v-else />
                        </div>
                    </div>
                    <div class="list_item_team_content" v-if="item.isExtend">
                        <div class="list_item_team_record" v-for="recordItem in item.list">
                            <template v-if="recordItem.punch_type === 'SINGLE'">
                                <p>{{ recordItem.punch_at_show }}</p>
                                <p>打卡地址：{{ recordItem.address }}</p>
                            </template>
                            <template v-else>
                                <p>
                                    {{ recordItem.start && recordItem.start.punch_at_show }} -
                                    {{ recordItem.end && recordItem.end.punch_at_show }}
                                </p>
                                <p>
                                    打卡地址：{{
                                        recordItem.start &&
                                        recordItem.start.location &&
                                        recordItem.end &&
                                        recordItem.end.location &&
                                        recordItem.start.location == recordItem.end.location
                                            ? recordItem.start.address
                                            : recordItem.start.address + "、" + recordItem.end.address_end
                                    }}
                                </p>
                            </template>
                        </div>
                        <p class="link-label_text" @click="handleClickTeamIndividual(item)">
                            <span class="link-label">查看记录</span>
                        </p>
                    </div>
                </li>
            </ul>
            <ul class="list_content" v-else>
                <li class="list_item" v-for="item in clockInRecordList" :key="item.id">
                    <template v-if="item.punch_type == 'SINGLE'">
                        <div>
                            <span class="list_item_labal">时间</span><span>{{ item.punch_at_show }}</span>
                        </div>
                        <div>
                            <span class="list_item_labal">位置</span><span>{{ item.address }}</span>
                        </div>
                        <div v-if="item.images && item.images.length">
                            <span class="list_item_labal">照片</span>
                            <div class="item_img_wrap">
                                <img
                                    v-for="(imgItem, imgIndex) in item.images"
                                    :key="imgIndex"
                                    :src="imgItem"
                                    alt=""
                                    @click="handleClickPreviewImg(imgIndex, item.images)"
                                />
                            </div>
                        </div>
                        <div v-if="item.remark">
                            <span class="list_item_labal">备注</span><span>{{ item.remark }}</span>
                        </div>
                    </template>
                    <template v-else>
                        <div>
                            <span class="list_item_labal">开始时间</span
                            ><span>{{ item.start && item.start.punch_at }}</span>
                        </div>
                        <div>
                            <span class="list_item_labal">位置</span><span>{{ item.start && item.start.address }}</span>
                        </div>
                        <div v-if="item.start && item.start.images && item.start.images.length">
                            <span class="list_item_labal">照片</span>
                            <div class="item_img_wrap">
                                <img
                                    v-for="(imgItem, imgIndex) in item.start.images"
                                    :key="imgIndex"
                                    :src="imgItem"
                                    alt=""
                                    @click="handleClickPreviewImg(imgIndex, item.start.images)"
                                />
                            </div>
                        </div>
                        <div v-if="item.start && item.start.remark">
                            <span class="list_item_labal">备注</span><span>{{ item.start.remark }}</span>
                        </div>
                        <div class="split_line"></div>
                        <div>
                            <span class="list_item_labal">结束时间</span>
                            <span v-if="item.end && item.end.is_skip">无需打卡</span>
                            <span v-else>{{ item.end && item.end.punch_at }}</span>
                        </div>
                        <template v-if="item.end && item.end.punch_at && !item.end.is_skip">
                            <div>
                                <span class="list_item_labal">位置</span
                                ><span>{{ item.end && item.end.address_end }}</span>
                            </div>
                            <div v-if="item.end && item.end.images && item.end.images.length">
                                <span class="list_item_labal">照片</span>
                                <div class="item_img_wrap">
                                    <img
                                        v-for="(imgItem, imgIndex) in item.end.images"
                                        :key="imgIndex"
                                        :src="imgItem"
                                        alt=""
                                        @click="handleClickPreviewImg(imgIndex, item.end.images)"
                                    />
                                </div>
                            </div>
                            <div v-if="item.end && item.end.remark">
                                <span class="list_item_labal">备注</span><span>{{ item.end.remark }}</span>
                            </div>
                        </template>
                    </template>
                </li>
            </ul>
            <div class="mobile_no_data" v-if="!clockInRecordList.length">
                <img src="https://download.hecoos.com/enlightv/2024-52/ca6fced677720b1c3d074bd3abafb296.png" alt="" />
                <p>未打卡~</p>
            </div>
        </div>
        <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
        <van-popup
            v-model="userDepartmentVisible"
            :overlay="false"
            position="right"
            :style="{ width: '100%', height: 'calc(100%)' }"
        >
            <userDepartmentPostSelection
                @popupClose="userDepartmentVisible = false"
                @success="userDepartmentPostSuccess"
            />
        </van-popup>
    </div>
</template>
<script>
import { GetIndividualDailyAttendanceCheck, GetMonthlyAttendanceCheck, GetGroupAttendanceCheck } from "@/api";
import { getLocation, formatDate, getNowDate } from "@/utils";
import { mapState } from "vuex";
import { Field, ImagePreview } from "vant";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
import userDepartmentPostSelection from "@/components/mComponents/userDepartmentPostSelection.vue";
import Calendar from "./component/calendar.vue";
import WeekCalendar from "./component/week_calendar.vue";
import MonthCalendar from "./component/month_calendar.vue";
export default {
    name: "mobileClockInRecord",
    components: { ReturnNavBar, FooterTabbar, userDepartmentPostSelection, Calendar, WeekCalendar, MonthCalendar },
    data() {
        return {
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            currentType: "mine", // 展示类型 团队=team，我的=mine，查看团队中的某个人=teamIndividual

            // 个人和团队的某月的打卡时间都有那几天
            calc_month: formatDate(new Date(), "year-month"),
            calc_type: "INDIVIDUAL",
            monthCheckDateList: [], // 获取月度打卡记录

            // 个人的打卡记录
            calc_date: getNowDate(),
            company_id: "",
            uid: "",

            // 团队打卡记录
            group_calc_type: "MONTHLY",
            group_calc_start_date: getNowDate(),
            group_calc_end_date: getNowDate(),
            staticTypeOption: [
                { text: "日统计", value: "DAILY" },
                { text: "周统计", value: "WEEKLY" },
                { text: "月统计", value: "MONTHLY" },
            ],

            // monthStatus: [], // 获取月度打卡记录

            // 选择部门/人员
            userDepartmentVisible: false,
            selectedUserDepartmentData: [],
            census: {
                punch_times: 0,
                punch_user_num: 0,
            },
            clockInRecordList: [],

            tabBarActive: 1,
            tabBarList: [
                {
                    icon: "icon-daka",
                    activeIcon: "icon-daka_xuanzhong",
                    routerName: "mobileClockIn",
                    title: "打卡",
                },
                {
                    icon: "icon-dakajilu",
                    activeIcon: "icon-dakajilu_xuanzhong",
                    routerName: "mobileClockInRecord",
                    title: "打卡记录",
                },
            ],
        };
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    created() {
        // 问题：
        // 1.筛选部门/人员的时候的数据不对
        // 2.查看部门某个人的时候记录时候月度打卡记录数据不对，（按照个人查询的方式不对，按照团队查询的时候，缺少部门id）
        // 3.记录数据不对（位置信息和时间需要处理， 区间打卡的数据无法区分无需打卡的状态，返回的状态不对）
    },
    methods: {
        // 预览图片
        handleClickPreviewImg(index, images) {
            ImagePreview({
                images,
                startPosition: index,
            });
        },
        // 时间类型切换
        groupCalcTypeChange(value) {},
        // 日统计-更改月份
        updateMonth(year, month, days) {
            this.calc_month = formatDate(year + "-" + month, "year-month");
            this.getMonthlyAttendanceCheckData();
        },
        // 日统计-更改日期
        updateDay(day) {
            if (this.currentType == "team") {
                this.group_calc_start_date = formatDate(day, "date");
                this.group_calc_end_date = formatDate(day, "date");
            } else {
                this.calc_date = formatDate(day, "date");
            }
            if (this.currentType == "team") {
                this.getGroupAttendanceCheckData();
            } else {
                this.getIndividualDailyAttendanceCheckData();
            }
        },
        // 周统计-更改周
        updateWeek(startDate, endDate) {
            this.group_calc_start_date = formatDate(startDate, "date");
            this.group_calc_end_date = formatDate(endDate, "date");
            this.getGroupAttendanceCheckData();
        },
        // 月统计-更改月
        updateGroupMonth(date) {
            this.group_calc_start_date = formatDate(date[0], "date");
            this.group_calc_end_date = formatDate(date[1], "date");
            this.getGroupAttendanceCheckData();
        },
        // 切换展示类型
        handleClickShowTypeChange() {
            if (this.currentType == "team") {
                this.currentType = "mine";
            } else if (this.currentType == "teamIndividual") {
                this.company_id = "";
                this.uid = "";
                this.currentType = "mine";
                this.getTypeData();
            } else {
                this.currentType = "team";
            }
            // this.$nextTick(() => {
            //     this.getTypeData();
            // });
        },
        getTypeData() {
            if (this.currentType == "team") {
                this.getGroupAttendanceCheckData();
            } else {
                this.getIndividualDailyAttendanceCheckData();
            }
            this.getMonthlyAttendanceCheckData();
        },
        // 展开和折叠
        handleClickExpendChange(item) {
            this.$set(item, "isExtend", !item.isExtend);
        },
        // 选择部门/人员
        handleClickSelectUserDepartment() {
            this.userDepartmentVisible = true;
        },
        // 选择部门/人员回调
        userDepartmentPostSuccess(data) {
            this.selectedUserDepartmentData = data;
            this.userDepartmentVisible = false;
            this.$nextTick(() => {
                this.getGroupAttendanceCheckData();
            });
        },
        // 查看团队中的某个成员数据
        handleClickTeamIndividual(item) {
            const firstData = item.list[0];
            const date =
                firstData.punch_type == "SINGLE"
                    ? formatDate(firstData.punch_at, "date")
                    : formatDate(firstData.start.punch_at, "date");
            this.calc_date = date;
            this.company_id = item.company_id;
            this.uid = item.uid;
            this.currentType = "teamIndividual";
            this.$nextTick(() => {
                this.getTypeData();
            });
        },
        // 获取单人和团队月度打卡记录时间
        getMonthlyAttendanceCheckData() {
            this.loading = true;
            let params = {
                calc_month: this.calc_month,
                calc_type: this.currentType == "team" ? "GROUP" : "INDIVIDUAL",
            };
            if (this.currentType == "team") {
                params.uid_list = this.selectedUserDepartmentData
                    .filter((item) => item.relate_type === "App\\Models\\User")
                    .map((uid) => uid.relate_id);
                params.department_id_list = this.selectedUserDepartmentData
                    .filter((item) => item.relate_type === "App\\Models\\Department")
                    .map((uid) => uid.relate_id);
            } else if (this.currentType == "teamIndividual") {
                // 在查团队中的某个人的时候，如果要按照团队查，缺少部门id字段
                params.uid_list = [this.uid];
                params.department_id_list = [];
            }
            GetMonthlyAttendanceCheck(params)
                .then((res) => {
                    if (res.code === 200) {
                        const list = res.data || [];
                        const monthCheckDateList = list.map((item) => {
                            const dateArr = item.split("-");
                            return dateArr.length ? Number(dateArr[2]) : "";
                        });
                        this.monthCheckDateList = monthCheckDateList;
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 获取单人的打卡记录
        getIndividualDailyAttendanceCheckData() {
            this.loading = true;
            let params = {
                company_id: this.company_id || this.userInfo.user.company_id,
                uid: this.uid || this.userInfo.user.id,
                calc_date: this.calc_date,
                page_source: "RECORD_PAGE",
            };
            GetIndividualDailyAttendanceCheck(params)
                .then((res) => {
                    if (res.code === 200) {
                        this.clockInRecordList = res.data || [];
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 获取团队打卡记录
        getGroupAttendanceCheckData() {
            this.loading = true;
            let params = {
                group_calc_type: this.group_calc_type,
                group_calc_start_date: this.group_calc_start_date,
                group_calc_end_date: this.group_calc_end_date,
                uid_list: this.selectedUserDepartmentData
                    .filter((item) => item.relate_type === "App\\Models\\User")
                    .map((uid) => uid.relate_id),
                department_id_list: this.selectedUserDepartmentData
                    .filter((item) => item.relate_type === "App\\Models\\Department")
                    .map((uid) => uid.relate_id),
            };
            GetGroupAttendanceCheck(params)
                .then((res) => {
                    if (res.code == 200) {
                        this.census = res.data.census || {};
                        this.clockInRecordList = res.data.list || [];
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.mobile_clockIn_record_wrap {
    background: rgba(247, 248, 250, 1);
    .mobile_head_operate {
        .iconfont {
            color: rgba(0, 0, 0, 1);
            margin-right: 8px;
        }
        span {
            width: auto;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18pxs;
            color: rgba(51, 51, 51, 1);
        }
    }
    .top_wrap {
        padding: 0 16px;
        &.top_wrap_padding {
            padding: 12px 16px;
        }
    }
    .top_static_wrap {
        padding: 8px 16px;
        display: flex;
        justify-content: space-between;
        .van-dropdown-menu {
            ::v-deep {
                .van-dropdown-menu__bar {
                    height: 22px !important;
                    background-color: rgba(247, 248, 250, 1);
                    box-shadow: none;
                    .van-dropdown-menu__title {
                        font-size: 14px;
                        font-weight: 500;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(102, 102, 102, 1) !important;
                    }
                }
                .van-dropdown-item__option--active {
                    color: rgba(41, 144, 255, 1);
                    .van-dropdown-item__icon {
                        color: rgba(41, 144, 255, 1);
                    }
                }
            }
        }
        .link-label {
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(41, 144, 255, 1);
        }
    }
    .top_static_time {
        border-radius: 8px;
        background: rgba(255, 255, 255, 1);
        margin-bottom: 1px;
    }
    .top_static_count {
        width: 100%;
        height: 69px;
        opacity: 1;
        border-radius: 8px;
        background: rgba(255, 255, 255, 1);
        display: flex;
        margin-bottom: 12px;
        & > div {
            flex: 1;
            text-align: center;
            padding-top: 6px;
            position: relative;
            &:nth-child(1) {
                &::after {
                    content: "";
                    position: absolute;
                    top: 6px;
                    bottom: 6px;
                    right: 0;
                    width: 1px;
                    background-color: rgba(232, 232, 232, 1);
                }
            }
            p {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(153, 153, 153, 1);
            }
            p:nth-child(2) {
                font-size: 24px;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 35px;
                color: rgba(51, 51, 51, 1);
            }
        }
    }
    .mobile_container {
        padding: 0 16px;
        .mobile_no_data {
            padding: 46px 0;
            text-align: center;
            img {
                width: 250px;
                margin: 0 auto;
            }
            p {
                margin-top: -40px;
                font-size: 16px;
                font-weight: 500;
                letter-spacing: 0px;
                line-height: 24px;
                color: rgba(41, 144, 255, 0.6);
            }
        }
    }
    .mobile_container {
        .list_title {
            padding: 6px;
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(153, 153, 153, 1);
        }
        .list_content {
        }
        .list_item {
            border-radius: 5px;
            padding: 12px 10px;
            margin-bottom: 12px;
            background-color: #ffffff;
            & > div {
                display: flex;
                justify-content: space-between;
                &:not(:last-child) {
                    margin-bottom: 12px;
                }
                .list_item_labal {
                    flex-shrink: 0;
                    width: 58px;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                }
                & > span:last-child,
                & > div {
                    flex: 1;
                    text-align: right;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                }
            }
            .item_img_wrap {
                display: flex;
                justify-content: flex-end;
                gap: 10px;
                img {
                    width: 30px;
                    height: 30px;
                    object-fit: contain;
                }
            }
            .split_line {
                width: 100%;
                height: 1px;
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    left: -10px;
                    right: -10px;
                    bottom: 0;
                    height: 1px;
                    background: rgba(243, 243, 243, 1);
                }
            }
            .link-label {
                margin-right: 12px;
            }
        }
        .list_item_team {
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            margin-bottom: 6px;
            .list_item_team_top {
                padding: 10px 16px 6px;
                display: flex;
                align-items: center;
                gap: 12px;
                .list_item_team_img {
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }
                .list_item_team_user {
                    flex: 1;
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(153, 153, 153, 1);
                    .name {
                        line-height: 22px;
                        color: rgba(51, 51, 51, 1);
                        margin-right: 8px;
                    }
                    p:nth-child(1) {
                        margin-bottom: 2px;
                    }
                }
                .list_item_team_icon {
                    .van-icon {
                        color: rgba(153, 153, 153, 1);
                        font-size: 16px;
                    }
                }
            }
            .list_item_team_content {
                padding: 0 16px 6px;
                .list_item_team_record {
                    padding: 6px 0;
                    border-top: 1px solid rgba(243, 243, 243, 1);
                    p {
                        font-size: 12px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 18px;
                        color: rgba(153, 153, 153, 1);
                    }
                }
                .link-label_text {
                    text-align: center;
                }
            }
        }
    }
}
</style>
<style lang="scss">
.van-image-preview__overlay {
    background: rgba(0, 0, 0, 0.3);
}
.van-image-preview {
    .van-image-preview__index {
        top: auto;
        bottom: 26px !important;
        text-shadow: none;
    }
}
</style>
